<!-- Figma 28563:27840: both videos in two cards and the way back on the left, "Optimize for
     platforms" on the right where the preview's order card stands. -->
<div class="order-layout downloads-layout" *ngIf="job">
  <section class="order-main downloads-main">
    <!-- A sample's videos: watched, never bought (owner, 2026-10-23). -->
    <ng-container *ngIf="isSample; else boughtTitle">
      <h1 class="flow-title">The sample's finished videos.</h1>
      <p class="flow-subtitle">Both <span class="rf-name" [title]="job.name">{{ job.name }}</span> videos, as every model gets them.</p>
    </ng-container>
    <ng-template #boughtTitle>
      <h1 class="flow-title">Ready for your next audience.</h1>
      <p class="flow-subtitle">Purchase complete. Both <span class="rf-name" [title]="job.name">{{ job.name }}</span> videos are ready.</p>
    </ng-template>

    <div *ngIf="isUpload && sample" class="rf-notice flow-message">
      <strong>Sample videos</strong>Uploads are switched off in this build — these are the {{ sample.name }} sample videos standing in for {{ sourceLabel }}.
    </div>

    <!-- To watch only (designer, 2026-09-25): every file comes from "Optimize for platforms". -->
    <div class="download-grid">
      <section class="download-card" *ngFor="let card of cards; trackBy: trackByKey">
        <div class="rf-stage download-stage">
          <!-- A sample's videos play, but are not offered to save: not the user's model. -->
          <video *ngIf="card.video" controls muted playsinline preload="metadata" [poster]="card.poster || null" [attr.aria-label]="job.name + ' ' + card.label + ' video'" [attr.controlslist]="isSample ? 'nodownload' : null" (contextmenu)="isSample && $event.preventDefault()">
            <source [src]="card.video" type="video/mp4">
          </video>
        </div>
        <div class="download-head">
          <h3>{{ card.label }}</h3>
          <span class="download-codec">{{ codec }} · {{ fps }} fps</span>
        </div>
        <p>{{ card.dimensions }} · MP4 · {{ seconds }} seconds</p>
      </section>
    </div>

    <!-- Not on a sample: that would rate our own render. -->
    <app-render-rating *ngIf="!isSample" class="downloads-rating" [job]="job"></app-render-rating>

    <ng-container *ngTemplateOutlet="nextStep"></ng-container>
  </section>

  <!-- "Optimize for platforms" (render-pack-card): the library's download button opens the same card.
       A sample's videos are watched, not downloaded: its card offers your own model instead (owner,
       2026-10-23). -->
  <aside *ngIf="isSample; else packCard" class="order-card" app-render-sample-card [job]="job"></aside>
  <ng-template #packCard>
    <aside class="order-card pack-card" aria-labelledby="render-pack-title" app-render-pack-card [job]="job"></aside>
  </ng-template>

  <!-- One column (a tablet, a phone): the way back under the platforms, after every download it
       speaks of (designer, 2026-10-01). Beside the videos on a desktop, as in her frame. -->
  <div class="downloads-foot">
    <ng-container *ngTemplateOutlet="nextStep"></ng-container>
  </div>
</div>

<ng-template #nextStep>
  <!-- A sample's way on is its card. -->
  <div *ngIf="!isSample" class="download-next">
    <p>You can return to these downloads without purchasing this model again.<br>The videos are in <a class="rf-text-link" routerLink="/render/library">your library</a> too.</p>
    <button class="flow-outline-button" type="button" (click)="onAnotherModel()">Preview another model</button>
  </div>
</ng-template>
